module.exports = __webpack_public_path__ + "img/9788956253749.8010e019.jpg";